module.exports = __webpack_public_path__ + "img/max-cloud-sync.ff8842ff.svg";